import {
  LayoutContext,
  LayoutContextProps,
} from '@/utils/providers/layoutContext/LayoutContext.tsx';
import { useContext } from 'react';

export const useLayoutContext = (): LayoutContextProps => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayoutContext must be used within a LayoutProvider');
  }
  return context;
};
